import {Text} from "@chakra-ui/react";
import { format as dateFnsFormat } from "date-fns"
import { TZDate } from "@date-fns/tz"
import {useTimezone} from "providers/timezone"

export default function FormattedDateString({date, format = ''}) {
    
    const {timezone} = useTimezone()

    const dateFormat = format || 'MMMM d, y'
    const str = dateFnsFormat(new TZDate(new Date(date), timezone), dateFormat)

    return <Text as="span" >{str}</Text>

}
